/**
 * Device detection utilities
 */

/**
 * Check if the current device is a mobile device
 */
export function isMobileDevice() {
  // Check for touch support
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check if primary input is touch (coarse pointer)
  // This is more reliable than user agent for iPads in desktop mode
  const hasTouchPrimary = window.matchMedia('(pointer: coarse)').matches;

  // Check user agent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  const isMobileUA = mobileRegex.test(userAgent.toLowerCase());

  // Check if device likely doesn't have a mouse (touch-only)
  // iPad Pro and other tablets will have touch but might not match user agent
  const isTouchOnly = hasTouch && !window.matchMedia('(pointer: fine)').matches;

  // Device is mobile if:
  // 1. Primary input is touch (coarse pointer), OR
  // 2. Has touch and matches mobile user agent, OR
  // 3. Is touch-only device (no fine pointer/mouse)
  return hasTouchPrimary || isTouchOnly || (hasTouch && isMobileUA);
}

/**
 * Check if device is in portrait orientation
 */
export function isPortrait() {
  return window.innerHeight > window.innerWidth;
}

/**
 * Check if device is in landscape orientation
 */
export function isLandscape() {
  return window.innerWidth >= window.innerHeight;
}

/**
 * Get device orientation as string
 */
export function getOrientation() {
  return isPortrait() ? 'portrait' : 'landscape';
}

/**
 * Add event listener for orientation changes
 */
export function onOrientationChange(callback) {
  window.addEventListener('resize', () => {
    callback(getOrientation());
  });

  // Also listen to orientation change event
  window.addEventListener('orientationchange', () => {
    callback(getOrientation());
  });
}
